module.exports = __webpack_public_path__ + "static/media/Onboarded_icon3.430a5922.png";